<template>
  <div class="form-group" :class="cssGap">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{ gap?: 'small' | 'medium' | 'large' }>(), {
  gap: 'large',
});

const cssGap = computed(() => `gap-${props.gap}`);
</script>

<style scoped lang="scss">
.form-group {
  display: flex;
  flex-direction: column;

  &.gap-small {
    gap: var(--t-spacing-sm);
  }

  &.gap-medium {
    gap: var(--t-spacing-md);
  }

  &.gap-large {
    gap: var(--t-spacing-lg);
  }
}
</style>
